import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  collapsed: false,
};

const navigationDrawerSlice = createSlice({
  name: 'navigationDrawer',
  initialState,
  reducers: {
    setCollapsed(state, action) {
      state.collapsed = action.payload;
    },
  },
});

export const { setCollapsed } = navigationDrawerSlice.actions;
export default navigationDrawerSlice.reducer;
